<template>
  <v-menu
    v-model="isOpened"
    class="zoox-menu"
    min-width="350px"
    :max-width="menuWidth"
    auto
    bottom
    offset-x
    offset-y
    content-class="mt-2"
    :close-on-content-click="false"
  >
    <template #activator="{on}">
      <z-icon v-on="on" @click="$emit('click')">{{ icon }}</z-icon>
    </template>

    <z-scrollbar>
      <div class="wrapper">
        <slot v-if="isLoading" name="loading">
          <z-skeleton-loader type="table"></z-skeleton-loader>
        </slot>

        <div v-else class="content">
          <div class="d-flex justify-end">
            <z-icon class="mb-2 mr-4 close-icon" @click="isOpened = false"
              >$close_rounded</z-icon
            >
          </div>
          <z-table
            id="custom-menu-table"
            :items="items"
            :headers="headers"
            @sort="onSort"
          >
            <template #header.type="header">
              <slot name="header-type" v-bind="header"></slot>
            </template>

            <template #header.value="header">
              <slot name="header-value" v-bind="header"></slot>
            </template>
          </z-table>
        </div>
        <div v-intersect="onLoadMore"></div>
      </div>
    </z-scrollbar>
  </v-menu>
</template>

<script>
/**
 * @displayName TableCategoryCounter
 */
export default {
  name: 'ZTableCategoryCounter',
  props: {
    /**
     * Define o icone de abertura do componente
     */
    icon: {
      type: String,
      default: '$keyboard_arrow_down_rounded',
    },
    /**
     * Array de itens do componente
     *
     * @typedef {type: any, value: any}
     */
    items: {
      type: Array,
      default: () => [],
    },
    /**
     * Define o texto da coluna `tipo`
     */
    typeText: {
      type: String,
      default: 'Tipo',
    },
    /**
     * Define o texto da coluna `value`
     */
    valueText: {
      type: String,
      default: 'Total',
    },
    /**
     * Define a largura máxima do menu
     */
    menuWidth: {
      type: [String, Number],
      default: 400,
    },
    /**
     * Define a largura da coluna `type`
     */
    typeHeaderWidth: {
      type: Number,
      required: false,
      default: 150,
    },
    /**
     * Define a largura da coluna `value`
     */
    valueHeaderWidth: {
      type: Number,
      required: false,
      default: 150,
    },
    /**
     * Aplica estado de loading no componente
     */
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpened: false,
    }
  },

  computed: {
    headers() {
      return [
        {
          text: this.typeText,
          value: 'type',
          sortable: true,
          width: this.typeHeaderWidth,
        },
        {
          text: this.valueText,
          value: 'value',
          sortable: true,
          width: this.valueHeaderWidth,
        },
      ]
    },
  },

  methods: {
    onSort(event) {
      this.$emit('sort', event)
    },
    onLoadMore(ev) {
      const event = ev[0] || {}
      if (event.isIntersecting) {
        this.$emit('load-more')
      }
    },
  },
}
</script>

<style lang="scss">
#custom-menu-table {
  th,
  thead,
  td {
    height: 28px !important;
    font-size: 0.78rem !important;
  }
}
</style>

<style scoped lang="scss">
.v-menu__content {
  background: var(--white);
  -ms-overflow-style: none;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  max-height: 270px !important;
}
.v-menu__content::-webkit-scrollbar {
  display: none;
}

.wrapper {
  background: var(--white);
  max-height: 250px;

  .content {
    padding: 15px;
  }
}
</style>
